import BaseModelAPI from '../BaseModelAPI';

export default class LookupList extends BaseModelAPI {

	static entity = 'lookuplist'
	static entityName = 'lookup';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
